// extracted by mini-css-extract-plugin
export default {"container":"navigation-control_container__2ET9X","button":"navigation-control_button__1FFp9"};